import {ConstraintsCollection, EmailTemplateFilterModel,} from '@spa/api';
import {ComponentTypesEnum} from 'appShared/enums';
import {Pagination, ReportTableColumn, ReportTableConfigInterface, ReportTableData} from 'appShared/components';
import {FilterControlInterface} from 'appShared/interfaces';
import {BaseControl} from 'appShared/classes';
import {
    MessageTemplateCustomerProductIdSelector,
    MessageTemplateCustomerSelector,
    MessageTemplateFieldCustomerProduct,
    MessageTemplateFieldNameApprovedBy,
    MessageTemplateFieldNameAuthor,
    MessageTemplateFieldNameCompany,
    MessageTemplateFieldNameID,
    MessageTemplateFieldNameStatus,
    MessageTemplateFieldNameTemplateName,
    prepareCompanyFilterControl,
    prepareProductFilterControl,
    prepareStatusFilterControl
} from 'appAssets/selectors';

export const PanelSettingsMessagingEmailTemplatesFilterControls = (): FilterControlInterface[] => {
    return [
        prepareStatusFilterControl(EmailTemplateFilterModel.getStatusSelector()),
        {
            name: EmailTemplateFilterModel.getNameSelector(),
            placeholder: MessageTemplateFieldNameTemplateName,
            controls: [
                new BaseControl({
                    name: EmailTemplateFilterModel.getNameSelector(),
                    value: null,
                    placeholder: MessageTemplateFieldNameTemplateName,
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 2,
        },
        prepareCompanyFilterControl(),
        {
            name: EmailTemplateFilterModel.getCreatedBySelector(),
            placeholder: MessageTemplateFieldNameAuthor,
            controls: [
                new BaseControl({
                    name: EmailTemplateFilterModel.getCreatedBySelector(),
                    value: null,
                    placeholder: MessageTemplateFieldNameAuthor,
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 5,
        },
        {
            name: EmailTemplateFilterModel.getApprovedBySelector(),
            placeholder: MessageTemplateFieldNameApprovedBy,
            controls: [
                new BaseControl({
                    name: EmailTemplateFilterModel.getApprovedBySelector(),
                    value: null,
                    placeholder: MessageTemplateFieldNameApprovedBy,
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                }),
            ],
            sortIndex: 6,
        },
        prepareProductFilterControl(),
    ];
};

export const PanelSettingsMessagingEmailTemplatesDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: EmailTemplateFilterModel.getIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EmailTemplateFilterModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MessageTemplateCustomerSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MessageTemplateCustomerProductIdSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EmailTemplateFilterModel.getCreatedBySelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EmailTemplateFilterModel.getApprovedBySelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EmailTemplateFilterModel.getStatusSelector(),
            value: null,
            hidden: false
        }),
    ];
};

export const PanelSettingsMessagingEmailTemplatesDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: MessageTemplateFieldNameID,
            selector: EmailTemplateFilterModel.getIdSelector()
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameTemplateName,
            selector: EmailTemplateFilterModel.getNameSelector()
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameCompany,
            selector: MessageTemplateCustomerSelector,
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldCustomerProduct,
            selector: MessageTemplateCustomerProductIdSelector,
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameAuthor,
            selector: EmailTemplateFilterModel.getCreatedBySelector(),
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameApprovedBy,
            selector: EmailTemplateFilterModel.getApprovedBySelector()
        }),
        new ReportTableColumn({
            label: MessageTemplateFieldNameStatus,
            selector: EmailTemplateFilterModel.getStatusSelector()
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: false
};

export const MessagingEmailTemplatesInitialFilterModel = (itemsPerPage = Pagination.defaultItemsPerPage) => {
    return new EmailTemplateFilterModel(
        new ConstraintsCollection(),
        Pagination.defaultPagesChunk - 1,
        EmailTemplateFilterModel.getCreatedTimeSelector(),
        Pagination.calculateItemsPerPagesChunk(itemsPerPage),
        false
    );
};
